import React, { useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { isArray } from 'lodash';
import { WishListContext } from 'Context/Wishlist';

// COMPONENTS
import CartItemValue from '../CartItemValue/CartItemValue';
import CartItemDetails from '../CartItemDetails/CartItemDetails';
import CartItemCounter from '../CartItemCounter/CartItemCounter';

import {
  Col,
  Divider,
  Row,
  VertLoading,
  VertTypography,
  
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Cart/CartItemListStyles.less';

import useGA from "Utils/Ga";
import { getObjectByKey } from 'Utils/getObjectByKey';
import { isObjectEmpty } from 'Utils';
import { pointsMask } from 'Utils/commons/points';
import ynToBool from 'Utils/ynToBool';
import CartItemProvider from "components/Cart/CartContent/CartItemList/CartItemProvider";
import CouponErrorSummary from 'components/Cart/CartCouponDiscount/CouponErrorSummary';
import { WarningOutlined } from "@ant-design/icons";
import { fetchCartUnavailableThunk } from "redux/Reducers/Cart/fetchCartUnavailableSlicer";

const CartItemDesktop = ({ groupedData, setHasItemUnavailable, hasItemUnavailable }) => {
  const { eventGaUnlimited } = useGA()
  const { simpleWishList } = useContext(WishListContext);

  // REDUCER
  const { errorListSkuUnavailable, dataListSkuUnavailable } = useSelector((state) => state.FetchCartUnavailable)
  const Catalog = useSelector(({ Catalog: data }) => data);
  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  const ShippingCart = useSelector(({ Shipping: data }) => data);
  const { errorCart } = useSelector(state => state.Cart)
  const Stores = useSelector(({ Stores: data }) => data);
  const Participants = useSelector(({ Participants: data }) => data);

  const [unavailableItems, setUnavailableItems] = useState({});

  const { coupon, errorSkus: errorSkuToAddCart, errorSkusCart } = itemsCartReducer;
  const couponIsValid = !coupon || coupon.isValid
  const { cart } = itemsCartReducer;
  const cartItems = cart?.items || [];


  const handleUnvaibleProductByCoupon = (sku) => {
    const isSkuInErrorList = (errorList) => errorList && errorList.length > 0 && errorList.includes(sku);
    
    if (isSkuInErrorList(errorSkusCart)) {
      return true;
    }
    if (isSkuInErrorList(errorSkuToAddCart)) {
      return true;
    }

    return false;
  };

  /* Vars */
  const isLoading = ynToBool(itemsCartReducer?.isLoading) || ynToBool(ShippingCart?.isLoading);
  const dispatch = useDispatch()
  
  const unavailableProductList = ShippingCart?.error && !isObjectEmpty(ShippingCart?.error)
    ? ShippingCart.error.subSkus
    : [];
    
    const { currencyConfiguration: { decimalPlaces, pointsName }, } = Catalog;
    const { value: { vendors: shippingVendors }, } = ShippingCart;
    const shippingError = ShippingCart && ShippingCart?.error && ShippingCart.error.subs;
    const cartError = itemsCartReducer && itemsCartReducer?.error;
    const hasShippingError = !!shippingError;
    const hasCartError = !!cartError;
    const replacementCEPIfParticipantHasNoCEP = sessionStorage.getItem('replacementCep');

    useEffect(() => {
      dispatch(fetchCartUnavailableThunk(Participants?.address?.zipCode?.value));
    }, []);
    
    useEffect(() => {
      handleCartUpdates();
    }, [cartItems, dataListSkuUnavailable, errorListSkuUnavailable?.length]);
    
    const verifySkuUnavailable = (errorSkus) => {
      const unavailableCartItems = cartItems.filter((item) =>
        errorSkus.includes(item.sku)
      );
    
      if (unavailableCartItems) {
        setHasItemUnavailable(true);

        const unavailableSkus = unavailableCartItems.reduce((acc, item) => {
          acc[item.sku] = true;
          return acc; 
        }, {});

        setUnavailableItems(unavailableSkus) 
      }
    };

    const handleCartUpdates = async () => {
      if (cartItems?.length > 0) {
    
        if (dataListSkuUnavailable === true) {
          clearSkuUnavailable();
          return;
        }
    
        if (errorListSkuUnavailable?.length > 0) {
          verifySkuUnavailable(errorListSkuUnavailable);
        }
      }
    };
    
    const clearSkuUnavailable = () => {
      setUnavailableItems({});
      setHasItemUnavailable(false);
    };
    

  const CountItemEvemGa4 = (item, qt, event) => {
    eventGaUnlimited({
      event,
      currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
      value: parseFloat(item.price),
    }, {
      items: [
        {
          item_id: item.sku,
          item_name: item.name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: item.vendor.name,
          price: parseFloat(item.price),
          quantity: qt
        }
      ]
    })
  }

  return Object.keys(groupedData || {}).map((vendorId) => {
    let shippingPriceByVendor = {};
    if (
      (!ShippingCart?.error || isObjectEmpty(ShippingCart?.error)) &&
      !ShippingCart?.isLoading
    ) {
      if (isArray(shippingVendors) && shippingVendors?.length > 0) {
        const vendorDataArray = shippingVendors.map((vendor) => ({
          [vendor.id]: {
            deliveryDate: vendor.deliveryDate,
            total: vendor.total,
            totalCash: vendor.totalCash,
          },
        }));

        const vendorArray = vendorDataArray.reduce((acc, vendor) => {
          const vendorId = Object.keys(vendor)[0];
          acc[vendorId] = vendor[vendorId];
          return acc;
        }, {});

        shippingPriceByVendor = getObjectByKey(vendorArray, vendorId);
      }
    }

    const totalShipping = shippingPriceByVendor && shippingPriceByVendor?.total;
    const hasShippingValue = totalShipping === 0 || totalShipping > 0;
    const isFreeShipping = hasShippingValue && totalShipping === 0;
    const dataStore = [...Stores.ecommerce, ...Stores.vouchers];

    const vendorItems = groupedData[vendorId];
    const vendorEcommerce = dataStore.find(
      (store) => store.supplierId === Number(vendorId)
    );

    const vendorVoucher = dataStore.find(
      (store) => store.supplierId === Number(vendorId)
    );


    const hasVoucher = cartItems.some(
      (item) =>
        item.vendor.type == 'PHYSICALVOUCHER' ||
        item.vendor.type == 'EXTERNALVOUCHERVIRTUAL'
    );

    const nameVendor = vendorEcommerce && vendorEcommerce?.name;
    const nameVendorVoucher = vendorVoucher && vendorVoucher?.name;

    const formattedTotalShipping = pointsMask(
      totalShipping,
      decimalPlaces,
      pointsName
    );


    return (
      <>
        <Col className="cart-item-shipping-divider" />
        <Col
          key={vendorId}
          className="cart-item-shipping col-12 vert-bg-light-lighter"
          shape="round"
          verticalSpacing="extra-small"
          spacing="small"
        >
          <VertTypography.Paragraph className="cart-vendor-name">
            Fornecido e entregue por{' '}
            <span>{hasVoucher ? nameVendorVoucher : nameVendor}</span>
          </VertTypography.Paragraph>

          {!!(
            ((!hasCartError || !hasShippingError) &&
              (replacementCEPIfParticipantHasNoCEP ||
                Participants?.address?.zipCode?.value)) ||
            hasShippingValue
          ) && (
              <VertTypography.Paragraph className="vendor-shipping-value"
                style={{
                  display: ynToBool(process.env.REACT_APP_HIDE_FREIGHT) ? 'none' : ''
                }}
              >
                Frete: {isLoading && <VertLoading size="small" />}
                {!isLoading && !hasShippingValue && <VertLoading size="small" />}
                {!isLoading && hasShippingValue ? (
                  isFreeShipping ? (
                    <span className="highlight">Grátis</span>
                  ) : (
                    <span>{`${formattedTotalShipping.value} ${formattedTotalShipping.label}`}</span>
                  )
                ) : (
                  ''
                )}
              </VertTypography.Paragraph>
            )}
        </Col>

        {vendorItems.map((item, index) => {
          const skuUnavailable = unavailableItems[item.sku];
          const totalValue = parseFloat(item.price) * parseFloat(item.quantity);
          const isInWishList = simpleWishList.get(item.sku);
          const isUnavailable = unavailableProductList.includes(item.sku);
          const vendorId = item?.vendor?.id;
          const couponUnavailableProduct = handleUnvaibleProductByCoupon(item.sku)
          const filterLastItem = index < (vendorItems.length - 1)
          return (
            <CartItemProvider item={{
              ...item,
              vendor: {
                name: hasVoucher ? nameVendorVoucher : nameVendor
              }
            }}>
              <Col key={item.sku} className="cart-item-wrapper">

                {
                  couponUnavailableProduct && (
                    <div className='cart-item-coupon-alert'>
                      <CouponErrorSummary error='Este produto não é valido para o cupom aplicado.' type={couponIsValid ? 'warning' : 'error'}
                      />
                    </div>
                  )
                }
                <Row className="cart-item">
                  <Col className="item-details padding-x-none margin-y-small" span={12}>
                    <CartItemDetails
                      imageAlt={item.name}
                      imageUrl={item.imageUrl}
                      itemName={item.name}
                      itemSeller={nameVendor}
                      shippingValue={null}
                      isFavorited={isInWishList}
                      sku={item.sku}
                      isUnavailable={isUnavailable}
                      skuUnavailable={skuUnavailable}
                    />
                  </Col>

                  <Col className="item-value" span={4}>
                    <CartItemValue value={item.price} />
                  </Col>

                  <Col className="item-quantity" span={4}>
                    <CartItemCounter
                      hasItemUnavailable={hasItemUnavailable}
                      isLoading={isLoading}
                      quantity={item.quantity}
                      sku={item.sku}
                      vendorId={vendorId}
                      gaCallback={(qt, nqt) => {
                        const quantityDiference = Math.max(qt, nqt) - Math.min(qt, nqt)
                        const event = qt < nqt ? 'add_to_cart' : qt > nqt ? 'remove_from_cart' : ''
                        if (event) CountItemEvemGa4({
                          ...item,
                          vendor: {
                            name: hasVoucher ? nameVendorVoucher : nameVendor
                          }
                        }, quantityDiference, event)
                      }}
                    />
                  </Col>

                  <Col className="item-total-value" span={4}>
                    <CartItemValue value={totalValue} />
                  </Col>
                </Row>
                <Row className="row-test">
                  {skuUnavailable && (
                    <div className='unavailable-container'>
                      <div className='unavailable-content'>
                        <WarningOutlined className="icon-unavailable"/>
                        <span>Produto Indisponível</span>
                      </div>
                    </div>
                    )}
                </Row>
                {filterLastItem && <Divider/>}
              </Col>
            </CartItemProvider>
          );
        })}
      </>
    );
  });

}

export default CartItemDesktop